export default "__VITE_ASSET__96Phtzh9__"